import { useQuery, gql } from '@apollo/client';
import client from 'src/data/api';
import { ScopeKey } from 'src/types';

const GET_PASSPORT_SCOPES = gql`
  query GetPassportScopes {
    portal_passport_scope(where: { deleted_at: { _is_null: true } }, order_by: { rank: asc }) {
      scope_key
    }
  }
`;

export const usePassportScopes = () => {
  const { data, loading } = useQuery<{ portal_passport_scope: { scope_key: ScopeKey }[] }>(GET_PASSPORT_SCOPES, {
    client,
  });

  const scopeKeys: ScopeKey[] = (data?.portal_passport_scope ?? []).map((s) => s.scope_key);

  return { scopeKeys, isLoading: loading };
};
